import { useCallback, useEffect, useState } from "react";
import {
  fetchShoutOutsAdminData,
  ShoutOutFilters,
  ShoutOutsAdminData
} from "../services/shoutOutsAdminService";

const initialFilters: ShoutOutFilters = {
  startDate: "",
  endDate: "",
  reason: "",
  recipientRole: "",
  giverRole: ""
};

export function useShoutOutsAdmin() {
  const [filters, setFilters] = useState<ShoutOutFilters>(initialFilters);
  const [data, setData] = useState<ShoutOutsAdminData | null>(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const refresh = useCallback(async (nextFilters = filters) => {
    setIsLoading(true);
    setError("");

    try {
      setData(await fetchShoutOutsAdminData(nextFilters));
    } catch {
      setData(null);
      setError("Unable to load shout-outs. Check Firebase permissions and indexes.");
    } finally {
      setIsLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    void refresh(initialFilters);
  }, []);

  return {
    data,
    error,
    filters,
    isLoading,
    refresh,
    setFilters
  };
}
